import React from "react";
import { useParams } from "react-router-dom";
import Page from "../Components/Page";
import ProfileForm from "../features/users/ProfileForm";
import useFetchData from "../hooks/useFetchData";
import { IProfile } from "../features/users/types";
import { useTranslation } from "react-i18next";

export default function ProfilePage() {
  const params = useParams();
  const { data: profile, isLoading } = useFetchData<IProfile>(
    `/users/${params.userid}/profile`
  );
  const { t } = useTranslation();
  return (
    <Page title={t("Profile")} isLoading={isLoading}>
      {profile && <ProfileForm profile={profile} />}
    </Page>
  );
}
